//-----------------------
// set character values
//-----------------------
export default function scrollTable(document, dir, elementId = "board") {

  // console.log("scrollTable called", dir, elementId);
  let content = document.getElementById(elementId);
  let top = 0;
  let left = 0;

  // console.log("scrollTable", dir, elementId, content);

  switch (dir) {
    case "up":
      top = 0;
      break;
    case "down":
      top = 99999;
      break;
    case "right":
      left = 99999;
      break;
    case "left":
      left = 0;
      break;
  }

  // console.log("scrollTable =>", dir, elementId, content, top, left);

  if (content) {
    // console.log("got content")
    if (dir == "up" || dir == "down") {
      // console.log("scrolling vert")
      content.scrollTo({
        top: top,
        behavior: "smooth",
      });
    } else {
      // console.log("scrolling horz")
      content.scrollTo({
        left: left,
        behavior: "smooth",
      });
    }
  }
}
